import { render, staticRenderFns } from "./RunnitAsset3D.vue?vue&type=template&id=d30281be&scoped=true"
import script from "./RunnitAsset3D.vue?vue&type=script&lang=ts"
export * from "./RunnitAsset3D.vue?vue&type=script&lang=ts"
import style0 from "./RunnitAsset3D.vue?vue&type=style&index=0&id=d30281be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30281be",
  null
  
)

export default component.exports